import { FIREBASE_COLLECTIONS } from "../constants/databases";
import { FirebaseCrudService } from "../firebase-crud.service";
import { OrderAndSubsUpdateResponse, SignalsStoreService } from "../signals-store.service";

export const updateFirebaseOrderAndSubTrigger = async (signalsStoreService: SignalsStoreService, firebaseCrudService: FirebaseCrudService) => {
    signalsStoreService.isSubscriptionUpdateOrigin.set(true);
    const userId = signalsStoreService.sessionSignal()?.accountInfo.id;
    if (!userId) return;


    const data: OrderAndSubsUpdateResponse = {
        shouldRefresh: true,
        date: Date.now()
    };

    const exists = await firebaseCrudService.existsDoc(FIREBASE_COLLECTIONS.ORDER_AND_SUBS_UPDATES, userId.toString());

    const setToFalseAfterUpdate = () => {
        firebaseCrudService.update(FIREBASE_COLLECTIONS.ORDER_AND_SUBS_UPDATES, userId, { shouldRefresh: false, date: Date.now() });
    }

    if (exists)
        firebaseCrudService.update(FIREBASE_COLLECTIONS.ORDER_AND_SUBS_UPDATES, userId, data).then(() => setToFalseAfterUpdate());
    else
        firebaseCrudService.add(FIREBASE_COLLECTIONS.ORDER_AND_SUBS_UPDATES, userId, data).then(() => setToFalseAfterUpdate());
}